module.exports = __webpack_public_path__ + "static/img/tab-ten.76b2d19a.png";